import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Box, Typography, Avatar, IconButton, Divider, Paper, TextField
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import { Send } from '@mui/icons-material';
import { format, parseISO } from 'date-fns';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { GetRecentMessages, createChatRoom, getBasicProfileSetting, getCommonChatRoom, getNetworks, getallGroup } from '../../Utils/apiService';
import Picker from '@emoji-mart/react';
import profilePic from "../../Assets/mentorImg1.png";
import { AuthUser } from '../../interfaces/Contexts';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import ChatIcon from '@mui/icons-material/Chat';

const ChatDetailPage = () => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.state, 'location state');
  const idTokens=localStorage.getItem('user');
  const idToken=JSON.parse(idTokens || '{}');
  
  const [selectedChat, setSelectedChat] = useState<any>(null);
  const [loadingChat, setLoadingChat] = useState(true);

  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;


  const [chatMessages, setChatMessages] = useState<{ content: string; senderId: string; timestamp: string }[]>([]);
  const [newMessage, setNewMessage] = useState('');
  const [profileUrl, setProfileUrl] = useState('');
  const [chatRoomId, setChatRoomId] = useState<string | null>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [stompClient, setStompClient] = useState<any>(null);
  const messageEndRef = useRef<HTMLDivElement>(null);

  // Load profile picture URL
  useEffect(() => {
    getBasicProfileSetting(userData?.applicantId).then((res) => {
      setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
    });
  }, [userData?.applicantId]);
  useEffect(() => {
    if (location.state?.chat) {
      setSelectedChat(location.state.chat);
      setLoadingChat(false);
    }
  }, [location.state]);
  useEffect(() => {
    if (location.state?.chat) {
      setSelectedChat(location.state.chat);
    }
  }, [location.state]);
  useEffect(() => {
    const fetchChatRoomId = async () => {
      if (!selectedChat?.id) return;

      try {
        const chatRoomRes = await getCommonChatRoom(userData.applicantId, selectedChat.id);

        if (chatRoomRes?.data?.data?.length === 0) {
          const payload = {
            name: 'p2p chat',
            participantIds: [userData.applicantId, selectedChat.id],
            adminId: userData.applicantId,
          };
          const createRoomRes = await createChatRoom(payload);
          setChatRoomId(createRoomRes?.data?.data?.id);
        } else {
          setChatRoomId(chatRoomRes?.data?.data?.[0]?.id ?? null);
        }
      } catch (err) {
        console.error('Failed to fetch/create chat room', err);
      }
    };

    if (selectedChat) {
      fetchChatRoomId();
    }
  }, [selectedChat]);

  // Load chat messages when chatId changes
  useEffect(() => {
    if (!chatRoomId) return;

    const fetchMessages = async () => {
      try {
        const res = await GetRecentMessages(chatRoomId, 1, 20);
        setChatMessages(res?.data?.data || []);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, [chatRoomId]);
  useEffect(() => {
    if (!chatRoomId) return;

    const socket = new SockJS(`https://turbosend-dev-bam-api.turboverse.co/chat-websocket`);
    const client = Stomp.over(socket);

    client.connect({}, () => {
      setStompClient(client);
      const subscription = client.subscribe(`/topic/chatRoom/${chatRoomId}`, (message: any) => {
        const received = JSON.parse(message.body);
        setChatMessages((prev) => [...prev, received]);
      });

      return () => {
        subscription.unsubscribe();
        client.disconnect();
      };
    });

    return () => {
      client.disconnect();
    };
  }, [chatRoomId]);


  // Load chat details if no selectedChat from location.state
  useEffect(() => {
    if (selectedChat || !chatId) {
      setLoadingChat(false);
      return;
    }

    const loadFallbackChat = async () => {
      try {
        console.log("Looking for chatId:", chatId);

        // Try to find chat in networks
        const res = await getNetworks(userData.applicantId);
        const networkChats = res?.data?.con || [];
        console.log("Network chats:", networkChats);

        const foundChat = networkChats.find((chat: any) => chat.Id === chatId);

        if (foundChat) {
          setSelectedChat({
            id: foundChat.Id,
            name: foundChat.Name,
            avatar: foundChat.Profile_Picture_URL__c || profilePic,
            isOnline: foundChat.Ken_Alumni_CRM__r?.records?.[0]?.Is_Logged_In__c || false,
          });
          console.log("Selected from network:", foundChat);
          setLoadingChat(false);
          return;
        }

        // Try groups if not found in networks
        const groupRes = await getallGroup(userData.applicantId);
        const groups = groupRes?.data?.data?.memberGroups || [];
        console.log("Group chats:", groups);

        const foundGroup = groups.find((group: any) => group.Id === chatId);

        if (foundGroup) {
          setSelectedChat({
            id: foundGroup.Id,
            groupName: foundGroup.Title__c,
            avatar: foundGroup.Cover_Image_Url__c || profilePic,
          });
          console.log("Selected from group:", foundGroup);
          setLoadingChat(false);
          return;
        }

        // Not found anywhere
        console.warn("Chat not found in either network or group.");
        setLoadingChat(false);

      } catch (error) {
        console.error('Error loading fallback chat data:', error);
        setLoadingChat(false);
      }
    };

    loadFallbackChat();
  }, [chatId, userData.applicantId, selectedChat]);

  const handleSendMessage = () => {
    if (!newMessage.trim() || !stompClient || !chatRoomId) return;

    const messagePayload = {
      content: newMessage.trim(),
      senderId: userData.applicantId,
      chatRoomId,
      attachmentUrl: null,
      timestamp: new Date().toISOString(),
      userName: userData?.applicantName,
    };
    

    stompClient.send(
      '/app/sendMessage',
      { Authorization: `Bearer ${idToken?.turbosendToken?.idToken}` },
      JSON.stringify(messagePayload)
    );
    setNewMessage('');
  };


  const formatDate = (timestamp: string) => format(parseISO(timestamp), 'MMMM d, yyyy');

  const groupedMessages = chatMessages.reduce((acc: any, msg: any) => {
    const date = formatDate(msg.timestamp);
    if (!acc[date]) acc[date] = [];
    acc[date].push(msg);
    return acc;
  }, {});

  // Sort date keys ascending (oldest first)
  const sortedDateKeys = Object.keys(groupedMessages).sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );

  // Scroll to bottom on new messages
  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages]);

  // Loading state
  if (loadingChat) {
    return (
      <Box p={2}>
        <Typography>Loading chat details...</Typography>
      </Box>
    );
  }

  // No chat found
  if (!selectedChat && !chatId) {
    return (
      <Box p={2}>
        <Typography>No chat selected. Please go back and try again.</Typography>
      </Box>
    );
  }

  const getTime = (dateStr: string) => {
    const date = new Date(dateStr);
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '85vh' }}>
      <Box sx={{ display: "flex", alignItems: "center", pb: 1, borderBottom: "1px solid #E0E0E0", gap: 2 }}>
        <Avatar src={selectedChat.avatar || profilePic} />
        <Typography variant="h5" >{selectedChat.name || selectedChat.groupName}</Typography>
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: "auto", height: "70vh", my: 2 }}>
        {
          sortedDateKeys.length > 0 ? <>
            {sortedDateKeys.map((date, index) => (
              <React.Fragment key={`date-${index}`}>
                <Box sx={{ textAlign: "center", color: "#777", fontSize: "12px", my: 1 }}>{date}</Box>
                {groupedMessages[date].map((msg: any, messageIndex: number) => (
             <Box
  key={messageIndex}
  sx={{
    display: "flex",
    py: 1,
    alignItems: "end",
    justifyContent: msg.senderId === userData.applicantId ? "flex-end" : "flex-start",
    gap: 1,
  }}
>
  {/* Avatar for the receiver */}
  {msg.senderId !== userData.applicantId && (
    <Avatar src={msg.receiverProfilePic || profilePic} sx={{ width: 30, height: 30 }} />
  )}
  
  <div>
    <Typography
      variant="caption"
      sx={{
        color: "#888",
        mt: 0.5,
        textAlign: msg.senderId === userData.applicantId ? "right" : "left",
        fontSize: '12px',
      }}
    >
      {msg.senderId === userData.applicantId ? <span>You,</span> : null}  {getTime(msg.timestamp)}
    </Typography>
    <Paper
      sx={{
        p: 1,
        borderRadius: 1,
        bgcolor: msg.senderId === userData.applicantId ? "#5981FF" : "#F1F1F1",
        color: msg.senderId === userData.applicantId ? "white" : "#38151D",
      }}
    >
      {msg.content}
    </Paper>
  </div>

  {/* Avatar for the sender */}
  {msg.senderId === userData.applicantId && (
    <Avatar src={profileUrl || profilePic} sx={{ width: 30, height: 30 }} />
  )}
</Box>

                ))}
              </React.Fragment>
            ))}</> : <Box sx={{
              marginTop: '30vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
            <ChatIcon sx={{ color: "#A0B6FF", width: '48px', height: '48px' }} />
            <Typography>Start a conversation</Typography>
          </Box>
        }

        <div ref={messageEndRef} />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 1, position: "relative", backgroundColor: 'white', padding: 2 }}>
        <TextField
          fullWidth
          size="small"
          variant="standard"
          style={{ padding: '8px' }}
          placeholder="Type a message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              handleSendMessage();
              event.preventDefault();
            }
          }}
          InputProps={{ disableUnderline: true }}
          sx={{ border: '1px solid #E7E7E7', borderRadius: 2, marginRight: 1 }}
        />

        {showEmojiPicker && (
          <Box sx={{ position: 'absolute', bottom: '84%', right: '-0.8%', zIndex: 1000 }}>
            <Picker
              onEmojiSelect={(emoji: { native: string }) => {
                setNewMessage((prev) => prev + emoji.native);
              }}
            />
          </Box>
        )}

        <IconButton onClick={() => setShowEmojiPicker((prev) => !prev)}>
          <EmojiEmotionsOutlinedIcon />
        </IconButton>
        <IconButton color="primary" onClick={handleSendMessage}>
          <Send />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatDetailPage;